import { Loading } from '@/components/Loading';
import classNames from 'classnames';
import type React from 'react';
import type { ButtonHTMLAttributes, HTMLAttributes } from 'react';
import styles from './index.module.css';

type BaseProps = {
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  size?: 'large' | 'medium';
  elementType?: 'button' | 'span';
  color?: 'primary' | 'warning';
};

// 条件付きで属性を適用
export type ButtonProps = {
  elementType?: 'button' | 'span';
} & (
  | ButtonHTMLAttributes<HTMLButtonElement>
  | HTMLAttributes<HTMLSpanElement>
) &
  BaseProps;

export const Button = ({
  onClick,
  disabled,
  loading,
  children,
  size = 'medium',
  elementType = 'button',
  color = 'primary',
  ...props
}: ButtonProps) => {
  if (loading) {
    return <Loading />;
  }

  const Tag: keyof JSX.IntrinsicElements =
    elementType === 'span' ? 'span' : 'button';

  const SizeStyleClassName = (() => {
    switch (size) {
      case 'large':
        return styles.large;
      case 'medium':
        return styles.medium;
      default: {
        return styles.medium;
      }
    }
  })();

  return (
    <Tag
      className={classNames(styles.button, 'primaryShadow', {
        SizeStyleClassName,
        [styles.colorWarning]: color === 'warning',
        [styles.disabled]: disabled,
      })}
      type={elementType === 'button' ? 'button' : undefined}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </Tag>
  );
};
